// Example class
let _this = (module.exports = {
	// Set the dom elements
	dom: {
		body: document.querySelector('body'),
	},

	// Set variables
	vars: {
		flag: false,
	},

	/**
	 * Init functions
	 */
	init: function () {
		// Menu toggle
		var menuToggle = document.getElementById('menuToggle');
		if (menuToggle) {
			menuToggle.addEventListener('click', function () {
				var menu = document.getElementById('navbar');
				if (menu) {
					// Toggle class
					if (menu.classList.contains('open')) {
						menu.classList.remove('open');
					} else {
						menu.classList.add('open');
					}

					// Add click lisrtener to the menu-toggle button
					menu.removeEventListener('click', toggleNavigation, true);
					menu.addEventListener('click', toggleNavigation, true);

					function toggleNavigation(evt) {
						if (evt.target.classList.contains('theme-menu-wrapper')) {
							menu.classList.remove('open');
						}
					}
				}
			});
		}

		// Dropdown menu
		var menuItems = document.querySelectorAll(
			'.theme-menu-wrapper .menu-item-has-children, .theme-menu-wrapper .menu-item-has-children > a',
		);
		if (menuItems && menuItems.length > 0) {
			menuItems.forEach(function (menuItem) {
				menuItem.addEventListener('click', function (evt) {
					switch (this.tagName) {
						case 'A':
							evt.preventDefault();
							break;

						case 'LI':
							if (this.classList.contains('open')) {
								this.classList.remove('open');
							} else {
								// // Hide all others
								// var opens = document.querySelectorAll('.menu-item-has-children.open');
								// if (opens && opens.length > 0) {
								// 	opens.forEach(function(open) {
								// 		open.classList.remove('open');
								// 	});
								// }
								this.classList.add('open');
							}
							break;
					}
				});
			});
		}

		// Dropdown button
		var dropdowns = document.querySelectorAll('.dropdown');
		if (dropdowns && dropdowns.length) {
			dropdowns.forEach((dropdown) => {
				var btn = dropdown.querySelector('.dropdown-toggle'),
					menu = dropdown.querySelector('.dropdown-menu');
				if (btn && menu) {
					btn.addEventListener('click', function () {
						menu.classList.toggle('open');
					});
				}
			});

			// Close the menu if someone clicked outside
			document.addEventListener('click', function (evt) {
				if (evt.target) {
					if (!evt.target.classList.contains('dropdown-toggle')) {
						var menus = document.querySelectorAll('.dropdown-menu.open');
						if (menus && menus.length) {
							menus.forEach((menu) => {
								menu.classList.remove('open');
							});
						}
					}
				}
			});
		}

		// Close dropdown menu on window resize
		document.addEventListener('resize', function () {
			var menuItems = document.querySelectorAll('.menu-item-has-children ul');
			if (menuItems && menuItems.length > 0) {
				menuItems.forEach(function (menuItem) {
					menuItem.removeAttribute('style');
				});
			}
		});

		// Close dropdown menu on window resize
		document.addEventListener('resize', function () {
			var menuItems = document.querySelectorAll('.menu-item-has-children ul');
			if (menuItems && menuItems.length > 0) {
				menuItems.forEach(function (menuItem) {
					menuItem.removeAttribute('style');
				});
			}
		});
	},
});
